<div>
  <div class="container-fluid py-4" id="print-section">
    <table style="width: 100%; border-collapse: collapse; font-size: 13px;">
      <thead>
        <tr>
          <th colspan="3" style="border: 1px solid black; padding: 6px; text-align: center;">Vivek Saptahik</th>
          <th colspan="5" style="border: 1px solid black; padding: 6px; text-align: center;">Issue Seller Credit Note Register</th>
          <th colspan="5" style="border: 1px solid black; padding: 6px; text-align: center;">Date {{ currentDate | date:'dd-MM-yyyy' }}</th>
        </tr>
        <tr>
          <th colspan="3" style="border: 1px solid black; padding: 6px; text-align: center;">Office Representative-wise</th>
          <th colspan="5" style="border: 1px solid black; padding: 6px; text-align: center;">In Details Credit Officer</th>
          <th colspan="2" style="border: 1px solid black; padding: 6px; text-align: center;">
            Date From {{ startDate | date:'dd-MM-yyyy' }} To {{ endDate | date:'dd-MM-yyyy' }}
          </th>
          <th colspan="3" style="border: 1px solid black; padding: 6px; text-align: center;">Page No</th>
        </tr>
        <tr>
          <th style="border: 1px solid black; padding: 6px;">Credit Note No</th>
          <th style="border: 1px solid black; padding: 6px;">CR Date</th>
          <th style="border: 1px solid black; padding: 6px;">Issue Seller Name</th>
          <th style="border: 1px solid black; padding: 6px;">Representative Name</th>
          <th style="border: 1px solid black; padding: 6px;">Office Rep Name</th>
          <th style="border: 1px solid black; padding: 6px;">Issue Name</th>
          <th style="border: 1px solid black; padding: 6px;">Issue Date</th>
          <th style="border: 1px solid black; padding: 6px;">Invoice No</th>
          <th style="border: 1px solid black; padding: 6px;">Invoice Date</th>
          <th style="border: 1px solid black; padding: 6px;">Invoice Net Amount</th>
          <th colspan="2" style="border: 1px solid black; padding: 6px;">Credit Note Amount</th>
          <th style="border: 1px solid black; padding: 6px;">Total Credit</th>
        </tr>
        <tr>
          <th colspan="10" style="border: 1px solid black; padding: 6px;"></th>
          <th style="border: 1px solid black; padding: 6px; text-align: center;">अंक परत</th>
          <th style="border: 1px solid black; padding: 6px; text-align: center;">अंक गहाळ/खराब</th>
          <th style="border: 1px solid black; padding: 6px;"></th>
        </tr>
      </thead>

      <tbody *ngFor="let data of CreditadvtOffInDFormBenas">
        <tr>
          <td colspan="13" style="border: 1px solid black; font-weight: bold; padding: 6px;">
            Office Representative: {{ data.off_rep_name }}
          </td>
        </tr>

        <tr *ngFor="let data1 of data.rep_data">
          <td style="border: 1px solid black; padding: 6px; text-align: end;">{{ data1.credit_voc_no }}</td>
          <td style="border: 1px solid black; padding: 6px; text-align: end;">{{ data1.voc_date }}</td>
          <td style="border: 1px solid black; padding: 6px; text-align: end;">{{ data1.issue_seller_name }}</td>
          <td style="border: 1px solid black; padding: 6px; text-align: end;">{{ data1.rep_name }}</td>
          <td style="border: 1px solid black; padding: 6px; text-align: end;">{{ data.off_rep_name }}</td>
          <td style="border: 1px solid black; padding: 6px; text-align: end;">{{ data1.DS_ISSUENAME }}</td>
          <td style="border: 1px solid black; padding: 6px; text-align: end;">{{ data1.DS_ISSUEDATE }}</td>
          <td style="border: 1px solid black; padding: 6px; text-align: end;">{{ data1.issue_invoice_no }}</td>
          <td style="border: 1px solid black; padding: 6px; text-align: end;">{{ data1.issue_invoice_date }}</td>
          <td style="border: 1px solid black; padding: 6px; text-align: end;">{{ data1.net_amt }}</td>
          <td style="border: 1px solid black; padding: 6px; text-align: end;">{{ data1.tds_amt }}</td>
          <td style="border: 1px solid black; padding: 6px; text-align: end;">{{ data1.other_credit_amt }}</td>
          <td style="border: 1px solid black; padding: 6px; text-align: end;">{{ data1.credit_v_amt }}</td>
        </tr>

        <tr>
          <td colspan="10" style="border: 1px solid black; padding: 6px; font-weight: bold;">Total:</td>
          <td style="border: 1px solid black; padding: 6px; text-align: end;">{{ data.tds_amt }}</td>
          <td style="border: 1px solid black; padding: 6px; text-align: end;">{{ data.other_credit_amt }}</td>
          <td style="border: 1px solid black; padding: 6px; text-align: end;">{{ data.total }}</td>
        </tr>
      </tbody>

      <tfoot>
        <tr>
          <td colspan="10" style="border: 1px solid black; padding: 6px; font-weight: bold;">Grand Total:</td>
          <td style="border: 1px solid black; padding: 6px; text-align: end;">{{ CreditadvtOffInDTotalTds }}</td>
          <td style="border: 1px solid black; padding: 6px; text-align: end;">{{ CreditadvtOffInDTotalOther }}</td>
          <td style="border: 1px solid black; padding: 6px; text-align: end;">{{ CreditadvtOffInDTotal }}</td>
        </tr>
      </tfoot>
    </table>
  </div>

  <div class="noPrint" style="margin-top: 20px; display: flex; justify-content: flex-end; gap: 16px; padding-right: 10%;">
    <button (click)="exportExcel('Contract_InDetails_Report')" mat-raised-button color="primary">ExportOff</button>
    <button mat-raised-button color="primary" [useExistingCss]="true" printSectionId="print-section" ngxPrint>Print</button>
    <button mat-button mat-dialog-close>Close</button>
  </div>
</div>
